import { Validators } from "@angular/forms";
import { required} from "@corporate-tailwind/corp-form";
import { SelectCurrency } from "@corporate-tailwind/model";
import { CurrencyDirection } from "src/app/features/pages/order/model/order-currency-direction.model";

export class CurrencyPurchaseDto {
    id: number | null = null;
    sourceCurrency: SelectCurrency | null = null;
    sourceAmount: number | null = null;
    targetCurrency: SelectCurrency | null = null;
    targetAmount: number | null = null;
    direction: CurrencyDirection = CurrencyDirection.SourceToTarget;
}

export class CurrencyPurchaseSchema extends CurrencyPurchaseDto {
    static schema = {
        id:                     { type: Number, builderOption: required },
        sourceCurrency:         { type: SelectCurrency, builderOption: required },
        sourceAmount:           { type: Number, builderOption:  { validators: [Validators.required], updateOn: 'blur' } },
        targetCurrency:         { type: SelectCurrency, builderOption: required },
        targetAmount:           { type: Number, builderOption: { validators: [Validators.required], updateOn: 'blur' } },
        direction:              { type: String, builderOption:  { validators: [Validators.required], defaultDisabled: false, defaultValue: CurrencyDirection.SourceToTarget } }
    };
}
